import { render, staticRenderFns } from "./CustomerDeliveryAddressSelect.vue?vue&type=template&id=fcdf45fe&scoped=true&"
import script from "./CustomerDeliveryAddressSelect.vue?vue&type=script&lang=js&"
export * from "./CustomerDeliveryAddressSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDeliveryAddressSelect.vue?vue&type=style&index=0&id=fcdf45fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdf45fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
